import { defineStore } from 'pinia'
import { ref } from 'vue'
import apiInstance from '@/utils/api'

export interface Partner {
  title: string
  value: number
}

export const usePartnersStore = defineStore('partners', () => {
  const partners = ref<Partner[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)
  const isLoaded = ref(false)

  const fetchPartners = async () => {
    // Skip if already loaded successfully
    if (isLoaded.value && partners.value.length > 0) {
      return
    }

    loading.value = true
    error.value = null

    try {
      const response = await apiInstance.get('/get-partners')

      if (response.data.error === false && response.data.data) {
        partners.value = response.data.data
        isLoaded.value = true
      } else {
        error.value = response.data.message || 'Failed to fetch partners'
        isLoaded.value = false
      }
    } catch (e) {
      error.value = e instanceof Error ? e.message : 'Network error while fetching partners'
      isLoaded.value = false
    } finally {
      loading.value = false
    }
  }

  const reset = () => {
    partners.value = []
    loading.value = false
    error.value = null
    isLoaded.value = false
  }

  return {
    partners,
    loading,
    error,
    isLoaded,
    fetchPartners,
    reset,
  }
})
